import { SvgBase } from "../svg.base";

export const Call = () => (
  <SvgBase
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12.432 18.303l.01.006c1.75 1.114 4.04.863 5.507-.604l.619-.62c.576-.576.576-1.51 0-2.087l-2.609-2.607c-.577-.576-1.51-.576-2.087 0-.276.277-.652.432-1.043.432-.392 0-.767-.155-1.044-.432L7.611 8.216c-.576-.577-.576-1.512 0-2.088.277-.276.433-.652.433-1.043 0-.391-.156-.766-.433-1.043L5.003 1.431c-.576-.576-1.51-.576-2.087 0l-.62.619C.83 3.517.579 5.806 1.693 7.557l.006.01c2.86 4.232 6.503 7.876 10.734 10.736z"
    />
  </SvgBase>
);